module["exports"] = [
  "#{city_name}#{city_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/address/city.js
// module id = 1424
// module chunks = 0